import i from './master-vendor.container';

export default i;
